(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sa-collection-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-sa-types]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = new URL(link.href);
  const current = new URL(window.location.href);
  for (const key of ['preview_theme_id', '_fd', 'pb']) {
    if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
  }
  event.preventDefault();
  window.location.assign(target.href);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sa-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sa-filter-panel')) {
  customElements.define('sa-filter-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.saReady) return;
      this.dataset.saReady = 'true';
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.sa-filter-open');
      opener.hidden = false;
      opener.addEventListener('click', () => dialog.showModal());
      this.querySelector('[data-sa-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) { const b = dialog.getBoundingClientRect(); if (event.clientX < b.left || event.clientX > b.right) dialog.close(); } });
      dialog.addEventListener('close', () => opener.focus());
      const current = new URL(window.location.href);
      this.querySelectorAll('form').forEach((form) => {
        for (const key of ['preview_theme_id', '_fd', 'pb']) {
          if (!current.searchParams.has(key)) continue;
          const hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = key; hidden.value = current.searchParams.get(key); form.append(hidden);
        }
        form.dataset.saEnhanced = 'true';
        form.addEventListener('submit', () => {
          form.querySelectorAll('input[type="number"]').forEach((input) => { if (input.value === '') input.disabled = true; });
        });
      });
      this.querySelectorAll('.sa-filter-clear').forEach((link) => {
        const reset = new URL(link.href);
        for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.searchParams.has(key)) reset.searchParams.set(key, current.searchParams.get(key));
        link.href = reset.href;
      });
      const layout = this.closest('.sa-shop-layout');
      const grid = layout && layout.querySelector('.product-grid-container');
      if (grid && !layout.querySelector('.sa-toolbar')) {
        const bar = document.createElement('div'); bar.className = 'sa-toolbar';
        const right = document.createElement('div'); right.className = 'sa-toolbar__right';
        bar.append(opener, right);
        const colours = document.querySelector('.sa-colour-bar__list');
        if (colours) { const wrap = colours.closest('.sa-colour-bar'); right.append(colours); if (wrap) wrap.remove(); }
        const count = grid.querySelector('.sa-results-count');
        if (count) right.append(count);
        grid.prepend(bar);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
